import React from "react";

const FEATURES = [
  {
    index: "01 / Discovery",
    icon: "bi-building",
    title: "Understand the Business",
    text: "Analyzes the enterprise core, positioning, offerings, and competitive regional advantages",
  },
  {
    index: "02 / Audience",
    icon: "bi-people-fill",
    title: "Study Target Customers",
    text: "Identifies commercial buyer profiles, demographics, purchasing habits, and enterprise requirements",
  },
  {
    index: "03 / Geography",
    icon: "bi-map",
    title: "Understand Preferred Market",
    text: "Maps the precise territory, city sectors, regional hubs, or export corridors selected by the business",
  },
  {
    index: "04 / Visibility",
    icon: "bi-broadcast",
    title: "Promote the Showcase",
    text: "Ensures the company's presence is routinely indexed, actively placed, and prominently surfaced",
  },
  {
    index: "05 / Catalog",
    icon: "bi-tag-fill",
    title: "Promote Products & Services",
    text: "Pushes individual items and service capabilities across the internal SELECTEZI promotional feeds",
  },
  {
    index: "06 / Initiatives",
    icon: "bi-stars",
    title: "Create Promotional Campaigns",
    text: "Structures tactical marketing pushes around milestones, special stock availability, and commercial events",
  },
  {
    index: "07 / Frequency",
    icon: "bi-arrow-repeat",
    title: "Feature Products Regularly",
    text: "Rotates hero products on a continuous schedule to prevent catalog staleness and sustain engagement",
  },
  {
    index: "08 / Intelligence",
    icon: "bi-bullseye",
    title: "Identify Potential Opportunities",
    text: "Scans ecosystem nodes for B2B requests, RFQs, supply needs, and strategic pairing opportunities",
  },
  {
    index: "09 / Consistency",
    icon: "bi-clock-history",
    title: "Maintain Promotional Activity",
    text: "Keeps marketing channels buzzing with structured output even when business owners are busy",
  },
  {
    index: "10 / Advisory",
    icon: "bi-eye-fill",
    title: "Recommend Products for Promotion",
    text: "Advises which high margin or trending inventory should be thrust into promotional rotations next",
  },
  {
    index: "11 / Timeliness",
    icon: "bi-calendar2-week",
    title: "Support Seasonal Campaigns",
    text: "Aligns marketing cadence with peak holiday seasons, industry expos, and regional harvest or trade cycles",
  },
  {
    index: "12 / Optimization",
    icon: "bi-magic",
    title: "Improve Business Presentation",
    text: "Refines descriptions, media packaging, and showcase copy for maximum conversion appeal",
  },
];

export default function TacticalScope() {
  return (
    <section className="section-py" id="what-it-does">
      <div className="container-selectezi">
        <div className="section-head">
          <span className="eyebrow-label">Tactical Scope</span>
          <h2 className="section-title">
            What Does a SELECTEZI Marketing Agent Do?
          </h2>
          <p className="section-subtitle mx-auto">
            Continuous tactical execution to keep your offerings actively
            visible.
          </p>
        </div>

        <div className="row g-4">
          {FEATURES.map((feature) => (
            <div className="col-md-6 col-lg-3" key={feature.title}>
              <div className="feature-card">
                <span className="icon-badge">
                  <i className={`bi ${feature.icon}`} />
                </span>
                <div className="feature-index">{feature.index}</div>
                <div className="feature-title">{feature.title}</div>
                <p className="feature-text">{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
